import { forwardRef, HTMLProps } from 'react';
import cn from 'classnames';
import s from './label.module.css';

export const Label = forwardRef<HTMLLabelElement, HTMLProps<HTMLLabelElement>>((props, ref) => {
  const { className, children, ...other } = props;

  const labelClassNames = cn(
    s.component,
    className,
    props.required && s.required,
    props.disabled && s.disabled,
  );

  return (
    <label className={labelClassNames} ref={ref} role="heading" aria-level={7} {...other}>
      {children}
    </label>
  );
});
